import React, { useEffect, useRef, useState } from 'react';
import api from '../../../api';

export function CreateChatProjectCard({ go }: { go: (page: string) => void }) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const mounted = useRef(false);
  const submitting = useRef(false);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  async function create(event: React.FormEvent) {
    event.preventDefault();
    const nextName = name.trim();
    if (submitting.current || !nextName || nextName.length > 120) return;
    submitting.current = true; setBusy(true); setError(null);
    try {
      const project = await api.createChatProject(nextName);
      if (mounted.current) go(`project:${project.projectId}`);
    } catch (err) { if (mounted.current) setError(err instanceof Error ? err.message : 'Could not create the chat project'); }
    finally { submitting.current = false; if (mounted.current) setBusy(false); }
  }
  return <section className="card" style={{ marginTop: 24, padding: 20 }} aria-label="Create a chat project">
    <h2 style={{ marginTop: 0 }}>Chat project</h2>
    <p>Group your chats in a named project. Add repositories when you need them.</p>
    <form onSubmit={event => void create(event)}>
      <label>Project name <input className="input" aria-label="Chat project name" value={name} maxLength={120} disabled={busy} onChange={event => setName(event.target.value)} /></label>
      <button className="btn btn-primary" type="submit" disabled={busy || !name.trim()} style={{ marginLeft: 8 }}>{busy ? 'Creating...' : 'Create chat project'}</button>
    </form>
    {error && <p role="alert">{error}</p>}
  </section>;
}
